import React, { Component, Fragment } from "react";
import {
  Metric,
  Error,
  formatDateFromData,
  selectFormat,
} from "./../../Utils/Utils.js";
import SharedSocialLineChart from "./../../Graphs/LineGraphs/SharedSocialLineChart/SharedSocialLineChart";

class InstagramPostMetrics extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: [
      {
        Metric: "Total Posts",
        Value: selectFormat(
          "number",
          this.props.data.stats.posts_total.value,
          "0,0"
        ),
      },
      {
        Metric: "Posts Images",
        Value: selectFormat(
          "number",
          this.props.data.stats.posts_photo.value,
          "0,0"
        ),
      },
      {
        Metric: "Posts Videos",
        Value: selectFormat("number", this.props.data.stats.posts_video.value),
      },
      {
        Metric: "Posts Reels",
        Value: selectFormat(
          "number",
          this.props.data.stats.post_reel.value,
          "0,0"
        ),
      },
      {
        Metric: "Posts Albums",
        Value: selectFormat(
          "number",
          this.props.data.stats.post_album.value,
          "0,0"
        ),
      },

      {
        Metric: "Stories",
        Value: selectFormat(
          "number",
          this.props.data.stats.stories.value,
          "0,0"
        ),
      },
      {
        Metric: "Video Views",
        Value: selectFormat(
          "number",
          this.props.data.stats.video_views.value,
          "0,0"
        ),
      },
      {
        Metric: "Reach",
        Value: selectFormat("number", this.props.data.stats.reach.value, "0,0"),
      },
      {
        Metric: "Engagements",
        Value: selectFormat(
          "number",
          this.props.data.stats.engagements.value,
          "0,0"
        ),
      },
      {
        Metric: "Eng. per 1k",
        Value: selectFormat(
          "number",
          this.props.data.stats.engagements_per_1k.value,
          "0,0"
        ),
      },
    ],
    opts: {
      type: "other",
    },
  });

  render() {
    const { data, project, project_id, title, insightsConfig } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    let preparedData = formatDateFromData(
      this.props.data.graph.map((e) => ({ ...e, name: e.full_date || e.name })),
      null,
      "name"
    );

    return (
      <Fragment>
        <div key={"stats"} className="row mb-4">
          <div className="col-12 mb-3">
            <h6 className="widget__metric-label">Total Posts</h6>
            <Metric {...data.stats.posts_total} size={"md"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Posts Images</h6>
            <Metric {...data.stats.posts_photo} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Posts Videos</h6>
            <Metric {...data.stats.posts_video} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Posts Reels</h6>
            <Metric {...data.stats.posts_reel} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Posts Albums</h6>
            <Metric {...data.stats.posts_album} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Stories</h6>
            <Metric {...data.stats.stories} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Video Views</h6>
            <Metric {...data.stats.video_views} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Reach</h6>
            <Metric {...data.stats.reach} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Engagements</h6>
            <Metric {...data.stats.engagements} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Eng. per 1k</h6>
            <Metric {...data.stats.engagements_per_1k} size={"sm"} />
          </div>
          {/* <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">% Paid</h6>
            <PieChart height={45} width={45}>
              <Pie
                dataKey="value"
                data={data.stats.paid}
                outerRadius="100%"
                innerRadius="75%"
                startAngle={450}
                endAngle={90}
              >
                {data.stats.paid.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__xsmall"
              >
                {numeral(data.stats.paid[0].value)
                  .divide(100)
                  .format("%")}
              </text>
            </PieChart>
          </div> */}
        </div>
        <SharedSocialLineChart
          ref={(el) => (this.childRef = el)}
          preparedData={preparedData}
          data={data}
          insights={data}
          insightsConfig={insightsConfig}
          project={project}
          project_id={project_id}
          title={title}
          color={"#F3108E"}
        />
      </Fragment>
    );
  }
}

export default InstagramPostMetrics;
